import {cargoApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import type {CargoCrmRepository, CargoCrmRepositoryParams} from './types'

function createCargoCrmRepository(params: CargoCrmRepositoryParams): CargoCrmRepository {
  const {fetch} = params

  return {
    fetchState(body) {
      return fetch({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        url: cargoApiURL(`cargo-crm/flow/phoenix/state`),
        body,
      })
    },
    fetchTicketInit(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery(cargoApiURL(`cargo-crm/flow/phoenix/ticket/init`), query),
        body,
      })
    },
    fetchTicketState(query) {
      return fetch({
        method: 'GET',
        url: addQuery(cargoApiURL(`cargo-crm/flow/phoenix/ticket/state`), query),
      })
    },
    fetchFillCompanyInfo(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery(cargoApiURL(`cargo-crm/flow/phoenix/ticket/fill-company-info`), query),
        body,
      })
    },
  }
}

export {createCargoCrmRepository}
